<!-- template-tree-viewer.component.html -->
<div class="tree-viewer">
    <div *ngFor="let node of nodes" class="tree-node">
        <div class="node-row">
            <button mat-icon-button type="button" *ngIf="node.children && node.children.length > 0"
                (click)="toggleExpand(node)">
                <mat-icon>{{ node.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>

            <mat-icon *ngIf="!(node.children && node.children.length > 0)"
                style="color: var(--app-outline); margin-right: 4px; width:24px">
                fiber_manual_record
            </mat-icon>

            <span class="node-name">{{ node.name }}</span>
            <div class="node-chips-column">
                <div *ngIf="node.value != null">
                    <span>
                        {{ node.value }}
                    </span>
                </div>
            </div>
            <!-- Chips & constraints in a separate, vertical column -->
            <div class="node-chips-column" *ngIf="!(node.children && node.children.length > 0)">
                <mat-chip-list>
                    <mat-chip color="primary" selected class="small-chip">
                        {{ getTypeLabel(node.type) }}
                    </mat-chip>
                </mat-chip-list>

                <!-- IF CONDITION: render value only if it is passed -->


                <span *ngIf="node.type === 'number' && (node.min != null || node.max != null)" class="constraints">
                    <ng-container *ngIf="node.min != null">Min: {{ node.min }}</ng-container>
                    <ng-container *ngIf="node.max != null">&nbsp;Max: {{ node.max }}</ng-container>
                </span>
            </div>

            <!-- Group chip for nodes with children, also in its own column -->
            <div class="node-chips-column" *ngIf="node.children && node.children.length > 0">

            </div>
        </div>

        <div *ngIf="node.expanded && node.children && node.children.length > 0" class="node-children">
            <app-template-tree-viewer [nodes]="node.children"></app-template-tree-viewer>
        </div>
    </div>
</div>